import { useAuth0 } from '@auth0/auth0-react';
import { Box, styled } from '@mui/material';
import { FC } from 'react';
import { getStoreFromStorage } from '../services/storeManager';
import { useIndependentApply } from '../services/flowManager';
import { TrackerButton } from './TrackerButtonWrapper';
import { ButtonName } from '../constants';
import { environment } from '../environment';

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

const StyledButton = styled(TrackerButton)(({ theme }) => ({
  width: theme.spacing(30),
  borderRadius: theme.spacing(1),
  alignSelf: 'center',
}));

const StyledSecondaryActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(-21),
}));

const StyledBackgroundImage = styled(Box)({
  backgroundImage: `url(${environment.storageUrl}/applications/salesapp/happyBackground.svg)`,
  height: '330px',
  width: '370px',
  backgroundPositionY: '20px',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '550px',
});

interface SelfApplyActionsProps {}

const SelfApplyStartActions: FC<SelfApplyActionsProps> = () => {
  const { loginWithRedirect } = useAuth0();
  const store = getStoreFromStorage();
  const selfApply = useIndependentApply();

  const handleButtonClick = async () => {
    if (store) {
      await selfApply();
    } else {
      loginWithRedirect();
    }
  };

  return (
    <Container>
      <StyledButton
        onClick={handleButtonClick}
        buttonName={store ? ButtonName.StartSelfApply : ButtonName.Login}
      >
        {store ? 'Apply' : 'Login'}
      </StyledButton>
      <StyledSecondaryActionsContainer>
        <StyledBackgroundImage />
      </StyledSecondaryActionsContainer>
    </Container>
  );
};

export default SelfApplyStartActions;
